<template>
  <div class="part part_contact">
    <div class="title">
      <img src="../../static/other/line.png" />
      <h2>联系我们</h2>
      <h2>CONTACT US</h2>
    </div>
    <el-row>
      <el-col :xs="24" :sm="12" class="contact_left">
        <div class="wrap">
          <h2>扶苏</h2>
          <ul>
            <li><img src="../../static/other/电话@2x-.png">电话：&nbsp;{{ message[0].content }}</li>
            <li><img src="../../static/other/地址@2x.png">地址：&nbsp;{{ message[1].content }}</li>
            <li><img src="../../static/other/邮编@2x.png">邮编：&nbsp;{{ message[2].content }}</li>
          </ul>
        </div>
      </el-col>
      <el-col :xs="24" :sm="12" class="contact_right">
        <img :src="map[0].img" />
      </el-col>
    </el-row>
  </div>

</template>
<script>
  export default {
    name: 'Contact',
    data() {
      return {
        message: [
          {
            title: "电话",
            content: "13585197482"
          },
          {
            title: "地址",
            content: "江浦街道珠泉花园11栋五单元110室"
          },
          {
            title: "邮编",
            content: "211800"
          },
        ],
        map: [
          {
            img: require('../../static/other/contactUs.png')
          }
        ]
      }
    }
  }
</script>

<style scoped>

  /* 公共 */
  .part {
    margin: 100px 0 200px 0;
  }

  .title {
    text-align: center;
    margin: 120px 0;
    color: #317bcb;
  }

  .contact_left {
    padding: 5% 10% 5% 20%;
  }

  .contact_left ul {
    list-style: none;
    padding-left: 0;
  }

  .contact_left ul li {
    text-decoration: none;
    line-height: 2em;
  }

  .contact_left li img {
    margin-right: 10px;
  }

  .contact_right img {
    width: 60%;
  }

  /* 屏幕设备适配 max-device-width: 400px */
  @media screen and (max-device-width: 415px) {
    .part {
      margin: 50px 0;
    }

    .title {
      margin: 0;
    }

    .contact_left {
      padding: 5% 15% 5% 15%;
    }

    .contact_right img {
      width: 90% !important;
      margin-left: 5%;
    }
  }
</style>